import React, { useState, useRef, useEffect } from 'react';
import { SelectOptions, MultiSelectOptions } from 'atoms/DropDown';
import { useDispatch, useSelector } from 'react-redux';
import { ContainedButton, ButtonType } from 'atoms/Buttons';
import DatePicker from 'react-datepicker';
import { MaterialTextInput } from 'atoms/MaterialInput';
import { submitFeedback } from '@kfc-global/react-shared/redux/Actions/FeedbackAction';
import { validatePhone, validateEmail, validateName, getContactKFCRequest } from '../../Utils/contactUsUtils';
import { CONTACTKFCCONSTANTS } from '../../Constants';
import { restrictUserToCharacter, restrictUserToNumber } from 'organisms/AccountPage/AU/accountPageUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ADDRESS_STORE_CONSTANTS from 'organisms/AccountPage/Presentation/AddressesAndStores/constant';
import { resetStores, getContactUSRestaurantDetails } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { NULL, TRUE, DATE_FORMATS } from 'common/constants/SharedConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import {
  getValueOrDefaultObject,
  contactUsRestaurantList,
  filtercontactUsRestaurantList,
  getFullAddressDetails,
  redirectToThankYouPage,
  getTernaryValue,
  recursiveAndCheck,
  safeLowerCase,
} from 'common/utilities/utils';
import 'react-datepicker/dist/react-datepicker.css';
export const renderSuggestions = (data, handleSelect, inputAddressValue) =>
  data?.map((suggestion, index) => {
    const { pinCode, name, addressLines, city, state, country, code } = suggestion;
    const addresses = {
      addressLines,
      city,
      state,
      pinCode,
      country,
    };
    return (
      <>
        {(inputAddressValue === pinCode ||
          name?.toLowerCase()?.includes(inputAddressValue?.toLowerCase()) ||
          city?.toLowerCase()?.includes(inputAddressValue?.toLowerCase())) && (
          <li
            key={index}
            data-testid='address-suggestion-id'
            className='address-suggestion-text'
            onClick={handleSelect(name, addresses, code)}
          >
            <ImageComponent
              srcFile={IMAGE_PATH.SuggestionItemSearchPin}
              alt={'googleMapLocation'}
              className='suggetion-pin'
            />
            <span className='contactKFC-text'>
              <strong>{name}</strong> {getFullAddressDetails(addresses)}
            </span>
          </li>
        )}
      </>
    );
  });

export const isFormValid = {
  postCodeSection: true,
  orderNumberSection: true,
  sortVisitSection: true,
  orderDateSection: true,
  orderTimeSection: true,
  enquiryDetailsSection: true,
  phoneSection: true,
  emailSection: true,
  publicationDetailsSection: true,
};
const postCodeValidation = (postCodeSection, contactKFCData, setPostCodeError) => {
  if (recursiveAndCheck(postCodeSection?.postCodeRequired === TRUE, postCodeSection?.postCodeVisible)) {
    setPostCodeError(!contactKFCData?.sugPinCode);
    isFormValid.postCodeSection = contactKFCData?.sugPinCode;
  }
};
const orderNumberValidation = (orderNumberSection, contactKFCData, setOrderNumberError) => {
  if (recursiveAndCheck(orderNumberSection?.orderNumberRequired === TRUE, orderNumberSection?.orderNumberVisible)) {
    setOrderNumberError(!contactKFCData?.ordernumber);
    isFormValid.orderNumberSection = contactKFCData?.ordernumber;
  }
};
const sortVisitValidation = (sortVisitSection, contactKFCData, setSortVisitError) => {
  if (recursiveAndCheck(sortVisitSection?.sortVisitRequired === TRUE, sortVisitSection?.sortVisitVisible)) {
    const visitData = contactKFCData?.sortvisit === CONTACTKFCCONSTANTS.DDSELECTONE;
    setSortVisitError(contactKFCData?.sortvisit ? visitData : true);
    isFormValid.sortVisitSection = visitData ? null : contactKFCData?.sortvisit;
  }
};
const visitDateValidation = (orderDateSection, contactKFCData, setVisitedDate) => {
  if (recursiveAndCheck(orderDateSection?.orderDateRequired === TRUE, orderDateSection?.orderDateVisible)) {
    setVisitedDate(!contactKFCData?.visitedDate);
    isFormValid.orderDateSection = contactKFCData?.visitedDate;
  }
};
export const visitTimeValidation = (orderTimeSection, contactKFCData, setVisitedTime) => {
  if (recursiveAndCheck(orderTimeSection?.orderTimeRequired === TRUE, orderTimeSection?.orderTimeVisible)) {
    setVisitedTime(!contactKFCData?.visitedTime);
    isFormValid.orderTimeSection = contactKFCData?.visitedTime;
  }
};
const enquiryDetailsValidation = (enquiryDetailsSection, contactKFCData, setDetailsAreaError) => {
  if (
    recursiveAndCheck(
      enquiryDetailsSection?.enquiryDetailsRequired === TRUE,
      enquiryDetailsSection?.enquiryDetailsVisible,
    )
  ) {
    setDetailsAreaError(!contactKFCData?.detailsArea);
    isFormValid.enquiryDetailsSection = contactKFCData?.detailsArea;
  }
};
const phoneSectionValidation = (phoneSection, contactKFCData, setPhoneNumberError) => {
  if (recursiveAndCheck(phoneSection?.phoneRequired === TRUE, phoneSection?.phoneVisible)) {
    const validatePhoneNumber = validatePhone(contactKFCData?.phonenumber);
    setPhoneNumberError(!contactKFCData?.phonenumber);
    isFormValid.phoneSection = getTernaryValue(validatePhoneNumber, contactKFCData?.phonenumber, null);
  }
};
const emailSectionValidation = (emailSection, contactKFCData, setEmailAddressError) => {
  if (recursiveAndCheck(emailSection?.emailRequired === TRUE, emailSection?.emailVisible)) {
    const validateEmailId = validateEmail(contactKFCData?.emailaddress);
    setEmailAddressError(!contactKFCData?.emailaddress);
    isFormValid.emailSection = getTernaryValue(validateEmailId, contactKFCData?.emailaddress, null);
  }
};
export const publicationDetailsValidation = (publicationDetailsSection, contactKFCData, setPublicationDetailsError) => {
  if (
    recursiveAndCheck(
      publicationDetailsSection?.publicationDetailsRequired === TRUE,
      publicationDetailsSection?.publicationDetailsVisible,
    )
  ) {
    setPublicationDetailsError(!contactKFCData?.publicationDetailsSection);
    isFormValid.publicationDetailsSection = contactKFCData?.publicationDetailsSection;
  }
};
const itemLabelCheck = (event, item) => {
  return item?.Label === event.target.value && item?.IsActive === 1 && item?.FormsMetadata;
};
export const specificDDOptionsLoad = (name, event, methodAndStateObject) => {
  const dropDownData = methodAndStateObject.getBodyFormData(name);
  if (name === CONTACTKFCCONSTANTS.SPECIFICDD || name === CONTACTKFCCONSTANTS.HELPDD) {
    dropDownData?.map(item => {
      if (itemLabelCheck(event, item)) {
        const metaDataObject = item?.FormsMetadata;
        metaDataObject?.map(metaitem => {
          if (metaitem?.id !== CONTACTKFCCONSTANTS.MESSAGE && metaitem?.id !== CONTACTKFCCONSTANTS.CONFIRMATION) {
            methodAndStateObject.setSubmitVisible(true);
          }
          methodAndStateObject.setPostCodeError(false);
          methodAndStateObject.setVisitedDate(false);
          methodAndStateObject.setVisitedTime(false);
          methodAndStateObject.setOrderNumberError(false);
          methodAndStateObject.setSortVisitError(false);
          methodAndStateObject.setDetailsAreaError(false);
          methodAndStateObject.setPhoneNumberError(false);
          methodAndStateObject.setEmailAddressError(false);
          methodAndStateObject.setPublicationDetailsError(false);
          switch (metaitem?.id) {
            case CONTACTKFCCONSTANTS.MESSAGE:
              methodAndStateObject.setMessageSection({
                ...methodAndStateObject.messageSection,
                messageVisible: true,
                messageText: metaitem.text,
              });
              break;
            case CONTACTKFCCONSTANTS.CONFIRMATION:
              methodAndStateObject.setConfirmationSection({
                ...methodAndStateObject.confirmationSection,
                confirmVisible: true,
                confirmLabel: metaitem.fieldlabel,
                confirmRequired: metaitem.isrequired,
                confirmArray: metaitem.fieldoption,
              });
              methodAndStateObject.setContactKFCData({ ...methodAndStateObject.contactKFCData, confirmation: '' });
              break;
            case CONTACTKFCCONSTANTS.POSTCODE:
              methodAndStateObject.setPostCodeSection({
                ...methodAndStateObject.postCodeSection,
                postCodeVisible: true,
                postCodeLabel: metaitem.fieldlabel,
                postCodeRequired: metaitem.isrequired,
              });
              methodAndStateObject.setContactKFCData({ ...methodAndStateObject.contactKFCData, sugPinCode: '' });
              break;
            case CONTACTKFCCONSTANTS.SORTVISIT:
              methodAndStateObject.setSortVisitSection({
                ...methodAndStateObject.sortVisitSection,
                sortVisitVisible: true,
                sortVisitLabel: metaitem.fieldlabel,
                sortVisitRequired: metaitem.isrequired,
                sortVisitArray: metaitem.fieldoption,
              });
              methodAndStateObject.setContactKFCData({
                ...methodAndStateObject.contactKFCData,
                sortvisit: '- Select One -',
              });
              break;
            case CONTACTKFCCONSTANTS.ORDER_DATE:
              methodAndStateObject.setOrderDateSection({
                ...methodAndStateObject.orderDateSection,
                orderDateVisible: true,
                orderDateLabel: metaitem.fieldlabel,
                orderDateRequired: metaitem.isrequired,
              });
              methodAndStateObject.setContactKFCData({ ...methodAndStateObject.contactKFCData, visitedDate: '' });
              break;
            case CONTACTKFCCONSTANTS.ORDER_NUMBER:
              methodAndStateObject.setOrderNumberSection({
                ...methodAndStateObject.orderNumberSection,
                orderNumberVisible: true,
                orderNumberLabel: metaitem.fieldlabel,
                orderNumberRequired: metaitem.isrequired,
              });
              methodAndStateObject.setContactKFCData({ ...methodAndStateObject.contactKFCData, ordernumber: '' });
              break;
            case CONTACTKFCCONSTANTS.ENQUIRY_DETAILS:
              methodAndStateObject.setEnquiryDetailsSection({
                ...methodAndStateObject.enquiryDetailsSection,
                enquiryDetailsVisible: true,
                enquiryDetailsLabel: metaitem.fieldlabel,
                enquiryDetailsRequired: metaitem.isrequired,
              });
              methodAndStateObject.setContactKFCData({ ...methodAndStateObject.contactKFCData, detailsArea: '' });
              break;
            case CONTACTKFCCONSTANTS.PHONE:
              methodAndStateObject.setPhoneSection({
                ...methodAndStateObject.phoneSection,
                phoneVisible: true,
                phoneLabel: metaitem.fieldlabel,
                phoneRequired: metaitem.isrequired,
              });
              methodAndStateObject.setContactKFCData({ ...methodAndStateObject.contactKFCData, phonenumber: '' });
              break;
            case CONTACTKFCCONSTANTS.PUBLICATION_DETAILS:
              methodAndStateObject.setPublicationDetailsSection({
                ...methodAndStateObject.publicationDetailsSection,
                publicationDetailsVisible: true,
                publicationDetailsLabel: metaitem.fieldlabel,
                publicationDetailsRequired: metaitem.isrequired,
              });
              methodAndStateObject.setContactKFCData({
                ...methodAndStateObject.contactKFCData,
                publicationDetailsSection: '',
              });
              break;
            case CONTACTKFCCONSTANTS.EMAILID:
              methodAndStateObject.setEmailSection({
                ...methodAndStateObject.emailSection,
                emailVisible: true,
                emailLabel: metaitem.fieldlabel,
                emailRequired: metaitem.isrequired,
              });
              methodAndStateObject.setContactKFCData({ ...methodAndStateObject.contactKFCData, emailaddress: '' });
              break;
            default:
              break;
          }
          return metaitem;
        });
        return item?.FormsMetadata;
      }
      return item;
    });
  }
};
export const updateContactKFCData = (name, event, setContactKFCData, contactKFCData) => {
  if (name === translateWithI18Next(TRANSLATE_MAPPING_KEY.SORTVISIT_TEXT)) {
    let title = Array.from(event.target.selectedOptions, option => option.title);
    setContactKFCData({ ...contactKFCData, [name]: title[0], sortmeal: event.target.value });
  } else {
    setContactKFCData({ ...contactKFCData, [name]: event.target.value });
  }
};
export const handlehelpDDenquiryDD_OptionsLoad = (
  name,
  event,
  bodyFormData,
  setStateFieldSection,
  setMoreSpecific,
  getItemOrItemIdFromDropdown,
) => {
  switch (name) {
    case CONTACTKFCCONSTANTS.HELPDD:
      setStateFieldSection();
      setMoreSpecific(false);
      getItemOrItemIdFromDropdown(bodyFormData?.firstDropdown, event, CONTACTKFCCONSTANTS.HELPDD);
      break;
    case CONTACTKFCCONSTANTS.ENQUIRYDD:
      setStateFieldSection();
      setMoreSpecific(true);
      getItemOrItemIdFromDropdown(bodyFormData?.secondDropdown, event, CONTACTKFCCONSTANTS.ENQUIRYDD);
      break;
    default:
      break;
  }
};
let getMethodAndStateObjectDetails = {};
export const setMethodAndStateObjectDetails = contactKfcObject => {
  getMethodAndStateObjectDetails = contactKfcObject;
};
export const handleDateChange = date => {
  getMethodAndStateObjectDetails.setVisitedDate(false);
  getMethodAndStateObjectDetails.setContactKFCData({
    ...getMethodAndStateObjectDetails.contactKFCData,
    visitedDate: date,
  });
};

export const handleTimeChange = time => {
  getMethodAndStateObjectDetails.setVisitedTime(false);
  getMethodAndStateObjectDetails.setContactKFCData({
    ...getMethodAndStateObjectDetails.contactKFCData,
    visitedTime: time,
  });
};

export const ContactKFCForm = props => {
  const { bodyFormData, isMobile, tenantId, history } = props;
  const suggestionRef = useRef(null);
  const dispatch = useDispatch();
  const feedBackResponse = useSelector(state => state.feedbackReducer);
  const isFeedbackResponseLoading = useSelector(data => data.feedbackReducer?.loading);
  const [contactKFCData, setContactKFCData] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [secondDDOptions, setSecondDDOptions] = useState(0);
  const [thirdDDOptions, setThirdDDOptions] = useState(0);
  const [messageSection, setMessageSection] = useState({});
  const [thanksUserSection, setThanksUserSection] = useState({});
  const [confirmationSection, setConfirmationSection] = useState({});
  const [postCodeSection, setPostCodeSection] = useState({});
  const [sortVisitSection, setSortVisitSection] = useState({});
  const [orderDateSection, setOrderDateSection] = useState({});
  const [orderTimeSection, setOrderTimeSection] = useState({});
  const [publicationDetailsSection, setPublicationDetailsSection] = useState({});
  const [orderNumberSection, setOrderNumberSection] = useState({});
  const [enquiryDetailsSection, setEnquiryDetailsSection] = useState({});
  const [moreSpecific, setMoreSpecific] = useState(false);
  const [phoneSection, setPhoneSection] = useState({});
  const [emailSection, setEmailSection] = useState({});
  const [postCodeError, setPostCodeError] = useState(false);
  const [orderNumberError, setOrderNumberError] = useState(false);
  const [visitedDate, setVisitedDate] = useState(false);
  const [visitedTime, setVisitedTime] = useState(false);
  const [sortVisitError, setSortVisitError] = useState(false);
  const [detailsAreaError, setDetailsAreaError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [emailAddressError, setEmailAddressError] = useState(false);
  const [publicationDetailsError, setPublicationDetailsError] = useState(false);
  const [submitVisible, setSubmitVisible] = useState(false);
  const [addresses, setSaveAddress] = useState(ADDRESS_STORE_CONSTANTS.INITIAL_STATE);
  const secondDDArray = [];
  const thirdDDArray = [];
  const [addressValue, setAddressValue] = useState('');
  const [restaurantList, setRestaurantList] = useState();
  const [inputAddressValue, setInputaddressValue] = useState('');
  const [staticMsg, setStaticMsg] = useState('');
  const setStateFieldSection = () => {
    setPostCodeSection({ ...postCodeSection, postCodeVisible: false });
    setSortVisitSection({ ...sortVisitSection, sortVisitVisible: false });
    setOrderDateSection({ ...orderDateSection, orderDateVisible: false });
    setOrderTimeSection({ ...orderTimeSection, orderTimeVisible: false });
    setPublicationDetailsSection({ ...publicationDetailsSection, publicationDetailsVisible: false });
    setOrderNumberSection({ ...orderNumberSection, orderNumberVisible: false });
    setEnquiryDetailsSection({ ...enquiryDetailsSection, enquiryDetailsVisible: false });
    setPhoneSection({ ...phoneSection, phoneVisible: false });
    setEmailSection({ ...emailSection, emailVisible: false });
    setMessageSection({ ...messageSection, messageVisible: false });
    setThanksUserSection({ ...thanksUserSection, thanksVisible: false });
    setConfirmationSection({ ...confirmationSection, confirmVisible: false });
    setSubmitVisible(false);
  };
  const storeData = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const { selectedContactUsRestaurantDetails = [] } = storeData;
  useEffect(() => {
    dispatch(getContactUSRestaurantDetails({ tenantId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const renderContantUsRestaurantList = contactUsRestaurantList(selectedContactUsRestaurantDetails);

  const getBodyFormData = name => {
    let response = [];
    switch (name) {
      case CONTACTKFCCONSTANTS.SPECIFICDD:
        response = bodyFormData?.thirdDropdown;
        break;
      case CONTACTKFCCONSTANTS.HELPDD:
        response = bodyFormData?.firstDropdown;
        break;
      default:
        break;
    }
    return response;
  };

  const getItemOrItemIdFromDropdown = (dropDownObject, event, name) => {
    switch (name) {
      case CONTACTKFCCONSTANTS.HELPDD:
        dropDownObject?.map(item => {
          if (item?.Label === event.target.value && item?.IsActive === 1) {
            setSecondDDOptions(item.Id);
            return item.Id;
          }
          return item;
        });
        break;
      case CONTACTKFCCONSTANTS.ENQUIRYDD:
        dropDownObject?.map(item => {
          if (item?.Label === event.target.value && item?.Parent === secondDDOptions) {
            setThirdDDOptions(item?.Id);
            return item?.Id;
          }
          return item;
        });
        break;
      default:
        break;
    }
  };

  const methodAndStateObject = {
    getBodyFormData: getBodyFormData,
    setSubmitVisible: setSubmitVisible,
    setPostCodeError: setPostCodeError,
    setVisitedDate: setVisitedDate,
    setVisitedTime: setVisitedTime,
    setOrderNumberError: setOrderNumberError,
    setSortVisitError: setSortVisitError,
    setDetailsAreaError: setDetailsAreaError,
    setPhoneNumberError: setPhoneNumberError,
    setEmailAddressError: setEmailAddressError,
    setPublicationDetailsError: setPublicationDetailsError,
    setMessageSection: setMessageSection,
    messageSection: messageSection,
    setConfirmationSection: setConfirmationSection,
    confirmationSection: confirmationSection,
    setPostCodeSection: setPostCodeSection,
    postCodeSection: postCodeSection,
    setSortVisitSection: setSortVisitSection,
    sortVisitSection: sortVisitSection,
    setContactKFCData: setContactKFCData,
    contactKFCData: contactKFCData,
    setOrderDateSection: setOrderDateSection,
    orderDateSection: orderDateSection,
    setOrderTimeSection: setOrderTimeSection,
    orderTimeSection: orderTimeSection,
    setPublicationDetailsSection: setPublicationDetailsSection,
    publicationDetailsSection: publicationDetailsSection,
    setOrderNumberSection: setOrderNumberSection,
    orderNumberSection: orderNumberSection,
    setEnquiryDetailsSection: setEnquiryDetailsSection,
    enquiryDetailsSection: enquiryDetailsSection,
    setPhoneSection: setPhoneSection,
    phoneSection: phoneSection,
    setEmailSection: setEmailSection,
    emailSection: emailSection,
  };
  setMethodAndStateObjectDetails(methodAndStateObject);
  const handleInput = event => {
    const { name } = event.target;
    switch (name) {
      case CONTACTKFCCONSTANTS.ORDER_NUMBER:
        setOrderNumberError(false);
        break;
      case CONTACTKFCCONSTANTS.CONFIRMATION:
        if (event.target.value === CONTACTKFCCONSTANTS.NO) {
          setEnquiryDetailsSection({
            ...enquiryDetailsSection,
            enquiryDetailsVisible: true,
            enquiryDetailsLabel: translateWithI18Next(TRANSLATE_MAPPING_KEY.ENQUIRY_STATIC_TEXT),
            enquiryDetailsRequired: 'true',
          });
          setPhoneSection({
            ...phoneSection,
            phoneVisible: true,
            phoneLabel: translateWithI18Next(TRANSLATE_MAPPING_KEY.PHONE_STATIC_TEXT),
            phoneRequired: 'true',
          });
          setEmailSection({
            ...emailSection,
            emailVisible: true,
            emailLabel: translateWithI18Next(TRANSLATE_MAPPING_KEY.EMAIL_STATIC_TEXT),
          });
          setThanksUserSection({
            ...thanksUserSection,
            thanksVisible: false,
            thanksLabel: translateWithI18Next(TRANSLATE_MAPPING_KEY.THANKS_STATIC_TEXT),
          });
          setSubmitVisible(true);
        } else {
          setEnquiryDetailsSection({ ...enquiryDetailsSection, enquiryDetailsVisible: false });
          setPhoneSection({ ...phoneSection, phoneVisible: false });
          setEmailSection({ ...emailSection, emailVisible: false });
          setThanksUserSection({
            ...thanksUserSection,
            thanksVisible: true,
            thanksLabel:
              translateWithI18Next(TRANSLATE_MAPPING_KEY.THANKS_STATIC_TEXT) +
              ' ' +
              contactKFCData?.fullname +
              ' ' +
              translateWithI18Next(TRANSLATE_MAPPING_KEY.GLAD_STATIC_TEXT),
          });
          setSubmitVisible(false);
        }
        break;
      case CONTACTKFCCONSTANTS.SORTVISIT:
        setSortVisitError(false);
        break;
      case CONTACTKFCCONSTANTS.DETAILSAREA:
        setDetailsAreaError(false);
        break;
      case CONTACTKFCCONSTANTS.PHONENUMBER:
        setPhoneNumberError(false);
        break;
      case CONTACTKFCCONSTANTS.EMAIL:
        setEmailAddressError(false);
        break;
      case CONTACTKFCCONSTANTS.PUBLICATION_DETAILS:
        setPublicationDetailsError(false);
        break;
      default:
        break;
    }
    handlehelpDDenquiryDD_OptionsLoad(
      name,
      event,
      bodyFormData,
      setStateFieldSection,
      setMoreSpecific,
      getItemOrItemIdFromDropdown,
    );
    specificDDOptionsLoad(name, event, methodAndStateObject);
    updateContactKFCData(name, event, setContactKFCData, contactKFCData);
  };
  bodyFormData?.secondDropdown?.map(item => {
    if (
      recursiveAndCheck(item?.Parent, item?.Parent !== NULL, item?.IsActive === 1, item?.Parent === secondDDOptions)
    ) {
      secondDDArray.push(item?.Label);
      return item.Label;
    }
    return item;
  });
  bodyFormData?.thirdDropdown?.map(item => {
    if (recursiveAndCheck(item?.Parent, item?.Parent !== NULL, item?.IsActive === 1, item?.Parent === thirdDDOptions)) {
      thirdDDArray.push(item?.Label);
      return item.Label;
    }
    return item;
  });
  const handleInputPostcode = event => {
    event.preventDefault();
    event.stopPropagation();
    setAddressValue(event.target.value);
    setInputaddressValue(event.target.value);
    const addressLines = [addresses?.addressLines[0], event.target.value];
    setSaveAddress({ ...addresses, addressLines: addressLines });
    filtercontactUsRestaurantList(renderContantUsRestaurantList, addressValue, setRestaurantList);
  };
  const setStatus = () => {
    setPostCodeError(false);
  };

  const handleSelect = (name, address, code) => () => {
    // When user selects a place, we can replace the keyword without request data from API
    // by setting the second parameter to "false"
    const restaurantDetails = name + ', ' + getFullAddressDetails(address);
    setContactKFCData({ ...contactKFCData, sugPinCode: code || null });
    setRestaurantList([]);
    dispatch(resetStores());
    setInputaddressValue(restaurantDetails);
  };

  const fieldValidationCheck = () => {
    postCodeValidation(postCodeSection, contactKFCData, setPostCodeError);
    orderNumberValidation(orderNumberSection, contactKFCData, setOrderNumberError);
    sortVisitValidation(sortVisitSection, contactKFCData, setSortVisitError);
    visitDateValidation(orderDateSection, contactKFCData, setVisitedDate);
    visitTimeValidation(orderTimeSection, contactKFCData, setVisitedTime);
    enquiryDetailsValidation(enquiryDetailsSection, contactKFCData, setDetailsAreaError);
    phoneSectionValidation(phoneSection, contactKFCData, setPhoneNumberError);
    emailSectionValidation(emailSection, contactKFCData, setEmailAddressError);
    publicationDetailsValidation(publicationDetailsSection, contactKFCData, setPublicationDetailsError);
  };
  const handleSubmit = event => {
    event.preventDefault();
    event.stopPropagation();
    fieldValidationCheck();
    const checkFormValidity = !Object.values(isFormValid).every(x => x);
    if (checkFormValidity) {
      setFormSubmitted(false);
    } else {
      const request = getContactKFCRequest(contactKFCData, tenantId);
      dispatch(submitFeedback(request));
      setFormSubmitted(true);
    }
  };
  useEffect(() => {
    switch (messageSection?.messageText) {
      case messageSection?.messageText?.split('<br>').length > 2:
        setStaticMsg(
          messageSection?.messageText?.split('<br>')[0] +
            '<br /><br />' +
            messageSection?.messageText?.split('<br>')[1] +
            '<br />' +
            messageSection?.messageText?.split('<br>')[2] +
            '<br />' +
            messageSection?.messageText?.split('<br>')[3],
        );
        break;
      case messageSection?.messageText?.split('<br>').length === 2:
        setStaticMsg(
          messageSection?.messageText?.split('<br>')[0] +
            '<br /><br />' +
            messageSection?.messageText?.split('<br>')[1],
        );
        break;
      case messageSection?.messageText?.split('<br>').length < 2:
        setStaticMsg(messageSection?.messageText?.split('<br>')[0]);
        break;
      default:
        setStaticMsg(messageSection?.messageText);
        break;
    }
  }, [messageSection]);

  let groupedArray = [];
  groupedArray = sortVisitSection?.sortVisitArray || [];
  const groupedOptions = {};
  groupedArray.forEach(option => {
    if (!groupedOptions[option.optgroup]) {
      groupedOptions[option.optgroup] = [];
    }
    groupedOptions[option.optgroup].push({
      value: option.value,
      text: option.text,
      category: option.optgroup,
    });
  });

  return (
    <>
      <div>
        <div>
          <MaterialTextInput
            placeholder={`${translateWithI18Next(TRANSLATE_MAPPING_KEY.FULL_NAME)}`}
            name={CONTACTKFCCONSTANTS.FULLNAME}
            data-testid='fullname-testid'
            onKeyPress={restrictUserToCharacter}
            value={contactKFCData?.fullname}
            onChange={handleInput}
            inputClassName={getTernaryValue(isMobile, 'full-name-common-mobile', 'full-name-common')}
            autoComplete='on'
            containerClassName={getTernaryValue(isMobile, 'full-name-common-mobile', 'full-name-common')}
            inputTestId={`${translateWithI18Next(TRANSLATE_MAPPING_KEY.FULL_NAME)}`}
            error={contactKFCData?.fullname?.length > 0 && !validateName(contactKFCData?.fullname)}
            helperTextClassName='error-text'
            aria-required='true'
            maxLength={30}
          />
        </div>
        {contactKFCData?.fullname && (
          <div className='contactUs-questions-container'>
            <div className='input-container'>
              <span className='questions-form-subheader'>
                {translateWithI18Next(TRANSLATE_MAPPING_KEY.HELP_DROPDOWN)}
              </span>
              <SelectOptions
                arialabelledby='listbox1label'
                options={bodyFormData?.firstDropdown?.map(item => {
                  return item.Label;
                })}
                selectClassName='select-topic-kfc-selection'
                optionContainerClassName='select-topic-kfc-option-conatiner'
                optionClassName='select-topic-kfc-option'
                name={CONTACTKFCCONSTANTS.HELPDD}
                data-testid='help-ddoptions'
                onChange={handleInput}
                testid='select-topic'
                selectedValue={contactKFCData?.helpDDOptions}
              />
            </div>
            {contactKFCData?.helpDDOptions === CONTACTKFCCONSTANTS.MEDIA_ENQUIRY && (
              <div
                className={getTernaryValue(
                  messageSection?.messageVisible,
                  'message-display-text',
                  'message-display-not-text',
                )}
              >
                <div
                  className={getTernaryValue(isMobile, 'input-container-textarea', 'input-container-desktop-message')}
                >
                  <div
                    className={getTernaryValue(
                      isMobile,
                      'textarea-desktop-message-mobile',
                      'textarea-desktop-message-single-link',
                    )}
                    dangerouslySetInnerHTML={{ __html: staticMsg }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        )}
        {recursiveAndCheck(
          contactKFCData?.fullname,
          secondDDArray.length,
          safeLowerCase(contactKFCData?.helpDDOptions) !== safeLowerCase(CONTACTKFCCONSTANTS.DDSELECTONE),
          contactKFCData?.helpDDOptions,
        ) && (
          <div className='contactUs-questions-container'>
            <div className='input-container'>
              <span className='questions-form-subheader'>
                {translateWithI18Next(TRANSLATE_MAPPING_KEY.ENQUIRY_DROPDOWN)?.split(
                  CONTACTKFCCONSTANTS.APPENQUIRY,
                )[0] +
                  `${contactKFCData?.helpDDOptions}` +
                  translateWithI18Next(TRANSLATE_MAPPING_KEY.ENQUIRY_DROPDOWN)?.split(
                    CONTACTKFCCONSTANTS.APPENQUIRY,
                  )[1]}
              </span>
              <SelectOptions
                arialabelledby='listbox1label'
                options={secondDDArray}
                selectClassName='select-topic-selection'
                optionContainerClassName='select-topic-option-conatiner'
                optionClassName='select-topic-option'
                name={CONTACTKFCCONSTANTS.ENQUIRYDD}
                data-testid='enquiry-ddoptions'
                onChange={handleInput}
                testid='select-topic'
                selectedValue={contactKFCData?.enquiryDDOptions}
              />
            </div>
          </div>
        )}
        {recursiveAndCheck(
          contactKFCData?.fullname,
          secondDDArray.length,
          contactKFCData?.enquiryDDOptions,
          safeLowerCase(contactKFCData?.enquiryDDOptions) !== safeLowerCase(CONTACTKFCCONSTANTS.DDSELECTONE),
          safeLowerCase(contactKFCData?.helpDDOptions) !== safeLowerCase(CONTACTKFCCONSTANTS.DDSELECTONE),
        ) && (
          <div className='contactUs-questions-container'>
            {moreSpecific && (
              <div className='input-container'>
                <span className='questions-form-subheader'>
                  {translateWithI18Next(TRANSLATE_MAPPING_KEY.SPECIFIC_DROPDOWN)}
                </span>
                <SelectOptions
                  arialabelledby='listbox1label'
                  options={thirdDDArray}
                  selectClassName='select-topic-selection'
                  optionContainerClassName='select-topic-option-conatiner'
                  optionClassName='select-topic-option'
                  name={CONTACTKFCCONSTANTS.SPECIFICDD}
                  data-testid='specific-ddoptions'
                  onChange={handleInput}
                  testid='select-topic'
                  selectedValue={contactKFCData?.specificDDOptions}
                />
              </div>
            )}
            <div
              className={getTernaryValue(
                messageSection?.messageVisible,
                'message-display-text',
                'message-display-not-text',
              )}
            >
              <div className={getTernaryValue(isMobile, 'input-container-textarea', 'input-container-desktop-message')}>
                <div
                  className={getTernaryValue(
                    isMobile,
                    'textarea-desktop-message-mobile',
                    'textarea-desktop-message-single-link',
                  )}
                  dangerouslySetInnerHTML={{ __html: staticMsg }}
                ></div>
              </div>
            </div>
          </div>
        )}
        {(contactKFCData?.specificDDOptions || contactKFCData?.helpDDOptions) && (
          <div>
            <div>
              {postCodeSection?.postCodeVisible && (
                <div>
                  <div className='input-container'>
                    <label className='contact-postcode-label'>
                      {postCodeSection?.postCodeLabel}
                      {getTernaryValue(postCodeSection?.postCodeRequired === TRUE, '*', '')}
                    </label>
                    <input
                      data-testid='search-input-postcode'
                      value={inputAddressValue}
                      onChange={handleInputPostcode}
                      name={CONTACTKFCCONSTANTS.ADDRESSNAME}
                      onFocus={() => setStatus()}
                      required
                      type='text'
                      autoComplete='off'
                    />
                    <ul
                      ref={suggestionRef}
                      className='contactKFC-list-suggestion'
                      data-testid='contactKFC-list-suggestion'
                    >
                      {renderSuggestions(restaurantList, handleSelect, inputAddressValue)}
                    </ul>
                  </div>
                  {postCodeError && (
                    <div
                      className={getTernaryValue(
                        isMobile,
                        'error-sub-kfc-postcode-mobile-container',
                        'error-sub-kfc-postcode-container',
                      )}
                    >
                      <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                      <div className='error-kfc-msg'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.POSTCODE_ERROR)}</div>
                    </div>
                  )}
                </div>
              )}
              {confirmationSection?.confirmVisible && (
                <div className='contactUs-questions-container'>
                  <div className='input-container'>
                    <span className='questions-form-subheader' id='listbox1label'>
                      {confirmationSection?.confirmLabel}
                      {'*'}
                    </span>
                    <SelectOptions
                      arialabelledby='listbox1label'
                      options={confirmationSection?.confirmArray}
                      selectClassName='select-topic-selection'
                      optionContainerClassName='select-topic-option-conatiner'
                      optionClassName='select-topic-option'
                      name={CONTACTKFCCONSTANTS.CONFIRMATION}
                      data-testid='confirmation-change'
                      onChange={handleInput}
                      testid='select-topic'
                      selectedValue={contactKFCData?.confirmation}
                    />
                  </div>
                </div>
              )}
              {thanksUserSection?.thanksVisible && (
                <div
                  className={getTernaryValue(isMobile, 'input-container-textarea', 'input-container-desktop-textarea')}
                >
                  <span className='contact-postcode-label'></span>
                  <textarea
                    className={getTernaryValue(isMobile, 'textarea-desktop-thanks-mobile', 'textarea-desktop-thanks')}
                    name={CONTACTKFCCONSTANTS.THANKSMESSAGE}
                    disabled
                    multiple={true}
                    maxLength={2000}
                    value={thanksUserSection?.thanksLabel}
                    data-testid='message-textarea'
                  />
                </div>
              )}
              {sortVisitSection?.sortVisitVisible && (
                <div className='contactUs-questions-container'>
                  <div className='input-container'>
                    <span className='questions-form-subheader' id='listbox1label'>
                      {sortVisitSection?.sortVisitLabel}
                      {getTernaryValue(sortVisitSection?.sortVisitRequired === TRUE, '*', '')}
                    </span>
                    <MultiSelectOptions
                      arialabelledby='listbox1label'
                      options={groupedOptions}
                      selectClassName='select-topic-selection'
                      optionContainerClassName='select-topic-option-conatiner'
                      optionClassName='select-topic-option'
                      name={CONTACTKFCCONSTANTS.SORTVISIT}
                      data-testid='sort-visit-change'
                      onChange={handleInput}
                      testid='select-topic'
                      selectedValue={contactKFCData?.sortVisit}
                    />
                  </div>
                  {sortVisitError && (
                    <div
                      className={getTernaryValue(
                        isMobile,
                        'error-sub-kfc-sortvisit-mobile-container',
                        'error-sub-kfc-sortvisit-container',
                      )}
                    >
                      <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                      <div className='error-msg'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.SORTVISIT_ERROR)}</div>
                    </div>
                  )}
                </div>
              )}
            </div>
            {orderDateSection?.orderDateVisible && (
              <div className='input-container'>
                <label className='contact-postcode-label'>
                  {orderDateSection?.orderDateLabel}
                  {orderDateSection?.orderDateRequired === TRUE && '*'}
                </label>
                <div className='date-time-input'>
                  <label className='contact-date-label'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.DATE)}</label>
                  <div data-testid='click-date-picker-open' className='date-pick'>
                    <DatePicker
                      selected={contactKFCData?.visitedDate}
                      onChange={handleDateChange}
                      maxDate={new Date()}
                      data-testid='search-input-visitdate'
                      dateFormat={DATE_FORMATS.MMMM_d_YYYY}
                    />
                    <img
                      src={IMAGE_PATH.Calendar}
                      className={getTernaryValue(isMobile, 'date-icon-mobile', 'date-icon-desktop')}
                      id='datePickerIcon'
                      alt=''
                    />
                  </div>
                  <span className='dropdown-img'></span>
                  {visitedDate && (
                    <div className='error-sub-kfc-visitdate-container'>
                      <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                      <div className='error-msg'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.VISITEDDATE_ERROR)}</div>
                    </div>
                  )}
                  <label className='contact-time-label'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.TIME)}</label>
                  <div data-testid='click-time-picker-open' className='time-pick'>
                    <DatePicker
                      selected={contactKFCData?.visitedTime}
                      onChange={handleTimeChange}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption={translateWithI18Next(TRANSLATE_MAPPING_KEY.TIME)}
                      data-testid='search-input-visittime'
                      dateFormat={DATE_FORMATS.H_MM_AA}
                    />
                  </div>
                  <span className='dropdown-img'></span>
                  {visitedTime && (
                    <div className='error-sub-kfc-visitdate-container'>
                      <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                      <div className='error-msg'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.VISITEDTIME_ERROR)}</div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {orderNumberSection?.orderNumberVisible && (
              <div>
                <MaterialTextInput
                  placeholder={getTernaryValue(
                    orderNumberSection?.orderNumberRequired === TRUE,
                    orderNumberSection?.orderNumberLabel + '*',
                    orderNumberSection?.orderNumberLabel,
                  )}
                  name={CONTACTKFCCONSTANTS.ORDER_NUMBER}
                  data-testid='search-input-ordernumber'
                  value={contactKFCData?.ordernumber}
                  onChange={handleInput}
                  inputClassName={getTernaryValue(isMobile, 'full-name-common-mobile', 'full-name-common')}
                  autoComplete='on'
                  containerClassName={getTernaryValue(isMobile, 'full-name-common-mobile', 'full-name-common')}
                  inputTestId={orderNumberSection?.orderNumberLabel}
                  aria-required='true'
                />
                {orderNumberError && (
                  <div className='error-sub-kfc-ordernumber-container'>
                    <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                    <div className='error-msg'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.ORDERNUMBER_ERROR)}</div>
                  </div>
                )}
              </div>
            )}
            {enquiryDetailsSection?.enquiryDetailsVisible && (
              <div
                className={getTernaryValue(isMobile, 'input-container-textarea', 'input-container-desktop-textarea')}
              >
                <span className='contact-postcode-label'>
                  {enquiryDetailsSection?.enquiryDetailsLabel}
                  {getTernaryValue(enquiryDetailsSection?.enquiryDetailsRequired === TRUE, '*', '')}
                </span>
                <textarea
                  className={getTernaryValue(isMobile, 'textarea-desktop-mobile', 'textarea-desktop')}
                  required={enquiryDetailsSection?.enquiryDetailsRequired}
                  name={CONTACTKFCCONSTANTS.DETAILSAREA}
                  multiple={true}
                  maxLength={2000}
                  value={contactKFCData?.detailsArea}
                  onChange={handleInput}
                  data-testid='enquiry-textarea'
                />
                {detailsAreaError && (
                  <div className='error-sub-kfc-textarea-container'>
                    <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                    <div className='error-msg'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.ENQUIRYDETAILS_ERROR)}</div>
                  </div>
                )}
              </div>
            )}
            {publicationDetailsSection?.publicationDetailsVisible && (
              <div>
                <MaterialTextInput
                  placeholder={getTernaryValue(
                    publicationDetailsSection?.publicationDetailsRequired === TRUE,
                    publicationDetailsSection?.publicationDetailsLabel + '*',
                    publicationDetailsSection?.publicationDetailsLabel,
                  )}
                  name={CONTACTKFCCONSTANTS.PUBLICATION_DETAILS}
                  data-testid='text-input-publicationDetailsSection'
                  value={contactKFCData?.publicationDetailsSection}
                  onChange={handleInput}
                  inputClassName={getTernaryValue(isMobile, 'full-name-common-mobile', 'full-name-common')}
                  autoComplete='on'
                  containerClassName={getTernaryValue(isMobile, 'full-name-common-mobile', 'full-name-common')}
                  inputTestId={publicationDetailsSection?.publicationDetailsLabel}
                  error={
                    contactKFCData?.publicationDetailsSection?.length > 0 && !contactKFCData?.publicationDetailsSection
                  }
                  helperText={`${translateWithI18Next(TRANSLATE_MAPPING_KEY.EMAIL_HELP_TEXT)}`}
                  helperTextClassName='error-text'
                  aria-required='true'
                  maxLength={CONTACTKFCCONSTANTS.PUBLICATION_DETAILS_MAXLENGTH}
                />
                {publicationDetailsError && (
                  <div className='error-sub-kfc-email-container'>
                    <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                    <div className='error-msg'>
                      {translateWithI18Next(TRANSLATE_MAPPING_KEY.EMPTY_PUBLICATION_DETAILS_ERR_MSG)}
                    </div>
                  </div>
                )}
              </div>
            )}
            {phoneSection?.phoneVisible && (
              <div>
                <MaterialTextInput
                  placeholder={getTernaryValue(
                    phoneSection?.phoneRequired === TRUE,
                    phoneSection?.phoneLabel + '*',
                    phoneSection?.phoneLabel,
                  )}
                  name={CONTACTKFCCONSTANTS.PHONENUMBER}
                  data-testid='text-input-phone'
                  value={contactKFCData?.phonenumber}
                  onChange={handleInput}
                  onKeyPress={restrictUserToNumber}
                  inputClassName={getTernaryValue(isMobile, 'full-name-common-mobile', 'full-name-common')}
                  autoComplete='on'
                  containerClassName={getTernaryValue(isMobile, 'full-name-common-mobile', 'full-name-common')}
                  inputTestId={phoneSection?.phoneLabel}
                  error={contactKFCData?.phonenumber?.length > 0 && !validatePhone(contactKFCData?.phonenumber)}
                  helperText={`${translateWithI18Next(TRANSLATE_MAPPING_KEY.PHONE_HELP_TEXT)}`}
                  helperTextClassName='error-text'
                  maxLength={10}
                  aria-required='true'
                />
                {phoneNumberError && (
                  <div
                    className={getTernaryValue(
                      isMobile,
                      'error-sub-kfc-phone-mobile-container',
                      'error-sub-kfc-phone-container',
                    )}
                  >
                    <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                    <div className='error-msg'>
                      {translateWithI18Next(TRANSLATE_MAPPING_KEY.EMPTY_PHONE_NUMBER_ERR_MSG)}
                    </div>
                  </div>
                )}
              </div>
            )}
            {emailSection?.emailVisible && (
              <div>
                <MaterialTextInput
                  placeholder={getTernaryValue(
                    emailSection?.emailRequired === TRUE,
                    emailSection?.emailLabel + '*',
                    emailSection?.emailLabel,
                  )}
                  name={CONTACTKFCCONSTANTS.EMAIL}
                  data-testid='text-input-email'
                  value={contactKFCData?.emailaddress}
                  onChange={handleInput}
                  inputClassName={getTernaryValue(isMobile, 'full-name-common-mobile', 'full-name-common')}
                  autoComplete='on'
                  containerClassName={getTernaryValue(isMobile, 'full-name-common-mobile', 'full-name-common')}
                  inputTestId={emailSection?.emailLabel}
                  error={contactKFCData?.emailaddress?.length > 0 && !validateEmail(contactKFCData?.emailaddress)}
                  helperText={`${translateWithI18Next(TRANSLATE_MAPPING_KEY.EMAIL_HELP_TEXT)}`}
                  helperTextClassName='error-text'
                  aria-required='true'
                />
                {emailAddressError && (
                  <div className='error-sub-kfc-email-container'>
                    <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                    <div className='error-msg'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.EMPTY_EMAIL_ERR_MSG)}</div>
                  </div>
                )}
              </div>
            )}
            {submitVisible && (
              <div className={getTernaryValue(isMobile, 'submit-button-mobile', 'submit-button-desktop')}>
                <ContainedButton
                  variant={ButtonType.primary}
                  aria-label='Submit'
                  onClickHandler={event => handleSubmit(event)}
                  id='startOrderItemButton'
                  inactive={isFeedbackResponseLoading}
                  loading={isFeedbackResponseLoading}
                  data-testid='empty-cart-start-order-button'
                >
                  <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY.SUBMIT)}</span>
                </ContainedButton>
              </div>
            )}
          </div>
        )}
      </div>
      {recursiveAndCheck(formSubmitted, feedBackResponse?.status === CONTACTKFCCONSTANTS.SUCCESSRESPONSE)
        ? redirectToThankYouPage({ history })
        : null}
    </>
  );
};
export default React.memo(ContactKFCForm);
